export const errorDictionaries = {
    "mch_name": "商户名称",
    "business_license": "营业执照号，数字编号",
    "organization_code": "组织机构代码",
    "tex_registration_no": "税务登记证件号",
    "legal_per_name": "企业法人",
    "resp_per_id_type": "责任人证件类型",
    "resp_per_id_no": "责任人证件号",
    "resp_per_name": "责任人姓名",
    "resp_per_telephone_no": "责任人手机",
    "resp_per_email": "责任人邮箱",
    "tel": "商户电话",
    "business_address": "营业地址",
    "business_license_pic": "营业执照图片",
    "resp_per_id_positive": "责任人证件正面照",
    "resp_per_id_opposite": "责任人证件反面照",
    "uni_credit": "统一社会信用",
    "legal_per_id_positive": "法人证件正面照",
    "legal_per_id_opposite": "法人证件反面照",
    "legal_per_id_type": "法人证件类型",
    "legal_per_id_no": "法人身份证号",
    "legal_per_telephone_no": "法人手机号",
    "public_account": "对公账户账号",
    "public_account_name": "开户名",
    "public_account_pic": "对公账户证明",
    "deposit_bank": "开户行名称",
    "union_bank": "支付行号",
    "deposit_bank_province": "开户行省",
    "deposit_bank_city": "开户行市",
    "sub_branch_bank": "支行名称",
    "change_apply_pic": "修改资料申请函图片"
}